import axios from 'axios'

const s3AxiosClient = axios.create()

export const uploadDocumentToPresignedS3 = (presignedUrl: string, file: File, fileType: string) =>
    // Different axios client to not send auth tokens
    s3AxiosClient.put(presignedUrl, file, {
        headers: {
            'Content-Type': fileType,
        },
    })
